export const attrModalHidden = 'data-modal-hidden'
export const ariaHidden = 'aria-hidden'
